// extracted by mini-css-extract-plugin
export default {"galleryActionButton":"NJ6Gj"};